import * as gs from './_csGbl';
import * as f from './_cmFTH';

import * as hf from './_hf';
import * as ht from './_ht';
import * as ihd from 'src/ihd';

//export { L } from './_cv_10a';
//export { D, saveAsync } from './_cv_10b';
export const ilz_10z = () => ({ // 新規登録を考慮し、毎回新規生成
  _10rz: {},
  _101z: {},
}) as ht.dz;

export const crt_10z = async (pz: {
  itlz: ht.dz,
}) => {
  const _gUserz = gs.useUserz();
  const __10z = ilz_10z();
  hf.udtDz(__10z._10rz, {
    ... ihd.i('_10r'),
    ... pz.itlz,
    _10r_31r1f: _gUserz.crt._31rz._fst,
  });
/*
  hf.udtDz(__10z._101z, {
    ... ihd.i('_101'),
    _101_31r1f: _gUserz.crt._31rz._fst,
  });
*/
  return __10z;
};

export const crt_101z = () => {
  const _gUserz = gs.useUserz();
  const __101z = {};
  hf.udtDz(__101z, {
    ... ihd.i('_101'),
    _101_31r1f: _gUserz.crt._31rz?._fst,
  });
  return __101z;
};

export const load_10rLsAsync = async (pz: {
  _dmn?: ht.n,
  _31r_fst?: ht.n,
  _10r_key?: ht.n,
  _10r_icn?: ht.s,
  _10ra2100s?: ht.s,
  _10rt1100i?: ht.n,
  cdn: ht.s,
}) => {
  let _cdn = 
    (pz._dmn) ?
      f.vdd(false, false) + ` AND _dmn = ${pz._dmn}`
    : f.vdd(false);
  if (pz._31r_fst) _cdn += ` AND _10r_31r1f = ${pz._31r_fst}`;
  if (pz._10r_key) _cdn += ` AND _key <> ${pz._10r_key}`;
  if (pz._10r_icn) _cdn += ` AND _icn = '${pz._10r_icn}'`;
  if (pz._10ra2100s) _cdn += ` AND _10ra2100s = '${pz._10ra2100s}'`;
  if (pz._10rt1100i) _cdn += ` AND _10rt1100i = ${pz._10rt1100i}`;
  _cdn += ` AND (${pz.cdn})`;
  //hf.l(`_cv_10 63: ${hf.s(_cdn)}`);
  const _ls = await f.loadLsAsync({
    tgt: '_10rs',
    cdn: _cdn,
    fld: '_key as key, _pfx as pfx, *',
    tailz: {
      odr: '_icn',
    }
  });
  //hf.l(`_cv_10 32: ${hf.s(_ls)}`);
  return _ls;
};

export const load_10rDzAsync = async (pz: {
  _31r_fst?: ht.n,
  _10r_key?: ht.n,
  _10r_icn?: ht.s,
  _10rt1100i?: ht.s,
  cdn?: ht.s,
  lwrType?: 1 | -1,
}) => {
  let _cdn = f.vdd(false);
  if (pz._31r_fst) _cdn += ` AND _10r_31r1f = ${pz._31r_fst}`;
  if (pz._10r_key) _cdn += ` AND _key = ${pz._10r_key}`;
  if (pz._10r_icn) _cdn += ` AND _icn = '${pz._10r_icn}'`;
  if (pz._10rt1100i) _cdn += ` AND _10rt1100i = ${pz._10rt1100i}`;
  if (pz.cdn) _cdn += ` AND (${pz.cdn})`;
  const _dz = await f.loadDzAsync({
    tgt: '_10rs',
    cdn: _cdn,
    lwrz: 
      pz.lwrType == -1 ?
      { // 101 はセキュリティを考慮し引用しない
        _101s: {
          tgt: '_101s',
          cdn: f.vdd() + ` AND _101_10r1k = {_10r_key}`,
          rlcz: {
            _10r_key: '_10rs._key',
          }
        },
      }
      : pz.lwrType == 1 ?
      { // 101 はセキュリティを考慮し引用しない
        _31rs: {
          tgt: '_31rs',
          cdn: f.vdd() + ` AND _fst = {_10r_31r1f}`, // SystemAdmin は取得できないことに注意
          rlcz: {
            _10r_31r1f: '_10rs._10r_31r1f',
          }
        }
      }
    : undefined,
  });
  return {
    _10rz: { ... _dz, cldz: undefined },
    _101z: hf.get1(_dz?.cldz?._101s, {}),
    _31rz: hf.get1(_dz?.cldz?._31rs, {}),
  };
};

export const save_10rDzAsync = async (pz: {
  _10z: ht.dz,
  cdn: ht.s,
}) => {
  let _cdn = f.vdd(false);
  _cdn += 
    pz._10z._10rz._key > 0 ?
      ` AND _key=${pz._10z._10rz._key}`
    : ` AND _icn='${pz._10z._10rz._icn}'`; // 同一 _icn での重複登録を抑制
  _cdn += ` AND (${pz.cdn})`;
  const _ls = await f.upsDzAsync({
    tgt: '_10rs',
    cdn: _cdn,
    dz: {
      ... pz._10z._10rz,
    },
    lwrz: {
      _101s: {
        tgt: '_101s',
        ls: [pz._10z._101z],          
        cdn: 
          pz._10z._10rz._key > 0 ?
            f.vdd(false) + ` AND _101_10r1k = ${pz._10z._10rz._key}`
          : f.vdd(false) + ` AND _101_10r1k = (SELECT _key FROM _10rs WHERE ${f.vdd(false)} AND _icn = '${pz._10z._10rz._icn}')`,
        udtz: {
          _101_31r1f: '_10rs._10r_31r1f',
          _101_10r1k: '_10rs._key',
        },
      }
    }
  });
  return {
    _10rz: { ... _ls[0], cldz: undefined },
  };
};
